/**
 * 商品ページ アニメーション
 */
// CDN bump 2026-07-23T19:07 (サムネhover/色選択スクロール修正の版数前進用)

document.addEventListener('DOMContentLoaded', function() {
  // アコーディオンのスムーズな開閉
  initSmoothAccordion();

  // サムネイルナビゲーション矢印を追加
  initThumbnailNavigation();

  // スクロールフェードイン
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // scroll-fade-in クラスを持つ要素を監視
  document.querySelectorAll('.scroll-fade-in').forEach(el => {
    observer.observe(el);
  });

  // 商品画像にスムーズなフェード効果
  const mediaItems = document.querySelectorAll('.product__media-item');
  mediaItems.forEach((item, index) => {
    item.style.animationDelay = `${index * 0.1}s`;
  });

  // 価格変更時のハイライト効果
  const priceElement = document.querySelector('.price');
  if (priceElement) {
    const priceObserver = new MutationObserver(() => {
      priceElement.classList.add('price--highlight');
      setTimeout(() => {
        priceElement.classList.remove('price--highlight');
      }, 500);
    });

    priceObserver.observe(priceElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // バリアント選択時のフィードバック
  const variantInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      const label = this.nextElementSibling;
      if (label) {
        label.style.animation = 'none';
        label.offsetHeight; // リフロー
        label.style.animation = 'selectPop 0.3s ease';
      }
    });
  });
});

// サムネイルナビゲーション矢印
function initThumbnailNavigation() {
  const thumbnailLists = document.querySelectorAll('.thumbnail-list');

  thumbnailLists.forEach(list => {
    // 既にナビゲーションがある場合はスキップ
    if (list.parentElement.classList.contains('thumbnail-nav-wrapper')) return;

    // ラッパーを作成
    const wrapper = document.createElement('div');
    wrapper.className = 'thumbnail-nav-wrapper';

    // 左矢印
    const leftBtn = document.createElement('button');
    leftBtn.className = 'thumbnail-nav-btn thumbnail-nav-btn--left';
    leftBtn.innerHTML = '‹';
    leftBtn.type = 'button';
    leftBtn.setAttribute('aria-label', '前へ');

    // 右矢印
    const rightBtn = document.createElement('button');
    rightBtn.className = 'thumbnail-nav-btn thumbnail-nav-btn--right';
    rightBtn.innerHTML = '›';
    rightBtn.type = 'button';
    rightBtn.setAttribute('aria-label', '次へ');

    // DOM構造を組み立て
    list.parentNode.insertBefore(wrapper, list);
    wrapper.appendChild(leftBtn);
    wrapper.appendChild(list);
    wrapper.appendChild(rightBtn);

    // スクロール量（サムネイル3つ分）
    const scrollAmount = 270;

    leftBtn.addEventListener('click', () => {
      list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', () => {
      list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // スクロール位置に応じてボタンの表示を更新
    function updateButtons() {
      leftBtn.style.opacity = list.scrollLeft <= 0 ? '0.3' : '1';
      rightBtn.style.opacity = list.scrollLeft >= list.scrollWidth - list.clientWidth - 5 ? '0.3' : '1';
    }

    list.addEventListener('scroll', updateButtons);
    updateButtons();
  });
}

// アコーディオンのスムーズな開閉
function initSmoothAccordion() {
  // バリアント変更時にアコーディオンをスムーズに閉じて画像エリアにスクロール
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[type="radio"], select')) {
      const isVariant = e.target.closest('variant-selects') &&
                        e.target.closest('.product-form__input');

      if (isVariant) {
        // 開いているアコーディオンをスムーズに閉じる
        document.querySelectorAll('details[open]').forEach(details => {
          const content = details.querySelector('.accordion__content');
          if (content) {
            // 高さをアニメーション
            content.style.overflow = 'hidden';
            content.style.height = content.offsetHeight + 'px';
            content.style.transition = 'height 0.3s ease, opacity 0.3s ease';

            requestAnimationFrame(() => {
              content.style.height = '0';
              content.style.opacity = '0';
            });

            setTimeout(() => {
              details.open = false;
              content.style.height = '';
              content.style.overflow = '';
              content.style.transition = '';
              content.style.opacity = '';
            }, 300);
          } else {
            details.open = false;
          }
        });

        // 画像エリアへの自動スクロールは行わない（色/サイズ選択でページ位置を動かさない）。
      }
    }
  });
}
